// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"iconWrapper__3ZeIn","clickable":"clickable__cdCoR"};